/*
 * Назначение: разбор текста согласия на обработку ПД со ссылками для превью
 * в админке. Логика совпадает с widget/src/consent-text.ts (виджет на сайте):
 * ссылки [текст](url) или <a href="url">текст</a>; url — http(s), относительный
 * (/obrabotka), mailto: или tel:. Прочие схемы ссылкой не становятся.
 */

export type ConsentPart =
  | { type: "text"; text: string }
  | { type: "link"; text: string; href: string };

const LINK_RE =
  /\[([^\]\n]{1,300})\]\(\s*([^)\s]{1,1000})\s*\)|<a\b[^>]*?\bhref\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s>]+))[^>]*>([\s\S]*?)<\/a\s*>/gi;

const SCHEME_RE = /^([a-z][a-z0-9+.-]*):/i;

export function safeHref(raw: string): string | null {
  const href = (raw || "").trim();
  // eslint-disable-next-line no-control-regex
  if (!href || /[\s\u0000-\u001f]/.test(href)) return null;
  const scheme = SCHEME_RE.exec(href);
  if (!scheme) return href;
  const s = scheme[1].toLowerCase();
  return s === "http" || s === "https" || s === "mailto" || s === "tel" ? href : null;
}

export function parseConsentText(text: string): ConsentPart[] {
  const parts: ConsentPart[] = [];
  let last = 0;
  LINK_RE.lastIndex = 0;
  let m: RegExpExecArray | null;
  while ((m = LINK_RE.exec(text)) !== null) {
    if (m.index > last) parts.push({ type: "text", text: text.slice(last, m.index) });
    const label = m[1] !== undefined ? m[1] : (m[6] || "").replace(/<[^>]*>/g, "");
    const href = safeHref(m[2] ?? m[3] ?? m[4] ?? m[5] ?? "");
    if (href && label.trim()) parts.push({ type: "link", text: label, href });
    else parts.push({ type: "text", text: label });
    last = LINK_RE.lastIndex;
  }
  if (last < text.length) parts.push({ type: "text", text: text.slice(last) });
  return parts;
}
